import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/gramps-graphql/gramps/docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`For the most concise docs, run:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`gramps <command> --help
`}</code></pre>
      <h2 {...{
        "id": "available-commands"
      }}>{`Available Commands`}</h2>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "#gramps-dev"
          }}><inlineCode parentName="a">{`gramps dev`}</inlineCode></a></li>
      </ul>
    </PageDescription>
    <h2 {...{
      "id": "gramps-dev"
    }}><inlineCode parentName="h2">{`gramps dev`}</inlineCode></h2>
    <p>{`Start a gateway (server) for development.`}</p>
    <h3 {...{
      "id": "usage"
    }}>{`Usage`}</h3>
    <pre><code parentName="pre" {...{}}>{`$ gramps dev [options]
`}</code></pre>
    <h3 {...{
      "id": "options"
    }}>{`Options`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`--data-source <path> [path..]`}</inlineCode>{` (aliases: `}<inlineCode parentName="p">{`--data-sources`}</inlineCode>{`, `}<inlineCode parentName="p">{`-d`}</inlineCode>{`)`}</p>
        <p parentName="li">{`Optional flag to specify which data source(s) to run locally for development. GrAMPS will look in the provided directory’s root and `}<inlineCode parentName="p">{`src`}</inlineCode>{` directory for data source files.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`# Run the default development gateway with a single data source
gramps dev --data-source ./data-source-one

# Run the default development gateway with two data sources
gramps dev --data-sources ./data-source-one ./data-source-two

# Run the default development gateway with two data sources use shorthand
gramps dev -d ./data-source-one ./data-source-two
`}</code></pre>
        <blockquote parentName="li">
          <p parentName="blockquote"><strong parentName="p">{`NOTE:`}</strong>{` Unless the `}<inlineCode parentName="p">{`--no-transpile`}</inlineCode>{` flag is set, the data source files will be transpiled using Babel with `}<a parentName="p" {...{
              "href": "https://github.com/gramps-graphql/gramps-cli/blob/master/.babelrc"
            }}>{`GrAMPS default settings`}</a>{`.`}</p>
        </blockquote>
        <br />
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`--gateway <path>`}</inlineCode>{` (alias: `}<inlineCode parentName="p">{`-g`}</inlineCode>{`)`}</p>
        <p parentName="li">{`Optional flag to specify a custom gateway for development. This gateway is `}<em parentName="p">{`not`}</em>{` transpiled, so point to your build folder if your code requires transpilation.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`# Run a custom gateway
gramps dev --gateway ./gateway.js

# Run a custom gateway plus a local data source
gramps dev --gateway ./gateway.js --data-source ./data-source-one
`}</code></pre>
        <br />
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`--mock`}</inlineCode></p>
        <p parentName="li">{`Optional flag to enable `}<a parentName="p" {...{
            "href": "https://www.apollographql.com/docs/graphql-tools/mocking.html"
          }}>{`data mocking`}</a>{`.`}</p>
        <p parentName="li">{`This option has an opposite — `}<inlineCode parentName="p">{`--live`}</inlineCode>{` — which is enabled by default and is therefore never necessary to set explicitly. However, it can be useful if you want to be very clear about what kind of data is being used.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`# Run the default development gateway in mock mode
gramps dev --mock

# Run a custom gateway in mock mode
gramps dev -g ./gateway.js --mock

# Explicitly run a custom gateway in live mode
gramps dev -g ./gateway.js --live
`}</code></pre>
        <br />
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`--no-transpile`}</inlineCode></p>
        <p parentName="li">{`An optional flag to disable transpilation of data sources via Babel. If this is set, the data source path needs to point to code that is already built and/or does not require transpilation to run properly.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`# Run the default development gateway with an untranspiled data source
gramps dev -d ./data-source-one --no-transpile
`}</code></pre>
        <p parentName="li">{`This option has an opposite — `}<inlineCode parentName="p">{`--transpile`}</inlineCode>{` — but this is enabled by default and therefore is never required to be set explicitly.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      